<template>
    <Dialog v-model:visible="visible" :style="{ width: '300px' }" :header="dialogHeader" :modal="true" class="p-fluid dialog-header" @hide="$emit('hide-dialog', true)">
        <div class="field">
            <label for="name">Station Name:</label>
            <InputText :class="{ 'p-invalid': submitted && !station.name }" id="name" type="text" v-model="station.name" autofocus />
            <small class="p-invalid" v-if="submitted && !station.name">Appliance Name is required</small>
        </div>
        <template #footer>
            <Button label="Cancel" icon="pi pi-times" class="p-button-danger" @click="visible = false" />
            <Button label="Submit" icon="pi pi-check" class="p-button-success" @click="submit" />
        </template>
    </Dialog>
</template>
<script setup>
import { storeToRefs } from 'pinia';
import { ref, defineEmits, computed, onUnmounted } from 'vue';
import { stationStore } from '../../../../../store/global-stores';
import { showToast } from '../../../../../utilities/toast-handler';

// emit
const emit = defineEmits(['hide-dialog']);

const visible = ref(true);
const submitted = ref(false);

const { station, editId } = storeToRefs(stationStore);

onUnmounted(() => {
    stationStore.initStation();
});

const editMode = computed(() => {
    return editId.value;
});

// computed properties starts
const dialogHeader = computed(() => {
    return editMode.value ? 'Update Existing Station' : 'Add New Station';
});

const submit = async () => {
    try {
        submitted.value = true;
        // const missingFields = [];
        //
        // if (!checklist.value.checklist_type_id) missingFields.push('Checklist Type is required');
        // if (!checklist.value.appliances_id) missingFields.push('Station is required');
        // // if (!checklist.value.stage) missingFields.push('Stage is required');
        // if (!checklist.value.date_from) missingFields.push('Start Date is required');
        // if (!checklist.value.date_to) missingFields.push('End Date is required');
        //
        //
        //
        // // Check if checklist items exist and have valid names
        // if (!checklist.value.items || checklist.value?.items?.length === 0) {
        //     missingFields.push('At least one checklist item is required');
        // } else {
        //     checklist.value.items.forEach((item, index) => {
        //         if (!item || typeof item !== 'object' || !('question' in item)) {
        //             missingFields.push(`Checklist item ${index + 1} is invalid`);
        //         } else if (!item.question || typeof item.question !== 'string' || item.question.trim() === '') {
        //             missingFields.push(`Checklist item ${index + 1} cannot be empty`);
        //         }
        //     });
        // }
        //
        // // Show toast if any required field is missing
        // if (missingFields.length > 0) {
        //     showToast({}, missingFields.join('\n')); // Display all missing fields in a single toast
        //     return;
        // }

        const response = editMode.value ? await stationStore.updateStation() : await stationStore.createStation();
        if (response) {
            stationStore.fetchAllStations();
            emit('hide-dialog');
        }
    } catch (error) {
            showToast({}, 'Input data invalid |' + error);

    }
};
</script>
